import { render, staticRenderFns } from "./CarouselRow.vue?vue&type=template&id=4c90e329&scoped=true&"
import script from "./CarouselRow.vue?vue&type=script&lang=js&"
export * from "./CarouselRow.vue?vue&type=script&lang=js&"
import style0 from "./CarouselRow.vue?vue&type=style&index=0&id=4c90e329&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c90e329",
  null
  
)

export default component.exports